<form class="providerForm">
    <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 button-padding-left">
            <p role="heading" aria-level="1">Please enter any information you have regarding the {{title}}
            </p>
        </div>
    </div>
    <div class="row " role="form">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <div class="col-md-10">
                <app-json-form *ngIf="isformloaded" [controlsData]="nonEnumeratedOrganizationFormData1.controls"
                    [formData]="nonEnumeratedOrganizationFormPart1" (valueChangeEvent)="valueChange($event)"
                    (InitializationCompletedEvent)="childInitComplete()"></app-json-form>
            </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <div class="col-md-10">
                <app-json-form *ngIf="isformloaded" [controlsData]="nonEnumeratedOrganizationFormData2.controls"
                    [formData]="nonEnumeratedOrganizationFormPart2" (valueChangeEvent)="valueChange($event)"
                    (InitializationCompletedEvent)="childInitComplete()"></app-json-form>
            </div>
        </div>
    </div>
</form>